export const autodeskAppPrivacy = {
	title: "Privacy",

	privacyStatement: "The only personally identifiable information that is collected is your email address that you use to log into your Autodesk app (i.e. Inventor). It is only used to determine your entitlement to use this app. It is not shared with anyone. It is not sold to anyone. The data itself resides in a cloud based database geographically located in the USA.",
	privacyTitle: "Autodesk App Store App Privacy",
};
